// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602031155/js/" + chunkId + "." + {"44":"be303969","225":"a2881ffc","481":"debde4c2","486":"aae7b902","770":"cd0ca061"}[chunkId] + ".0.9632818718812861.chunk.js";
};